<template>
    <div class="wrapper">
        <div class="modal">
            <div name="terms" class="terms">
                <close-button 
                    @close="closeTerms"
                />
                <span class="title">위임 청구 동의 약관 내용</span>
                <div class="bar" style="margin-top: 20px;" @click="privacyOpen">
                    <span>개인정보 수집 및 이용 동의</span>
                    <img class="icon" src="../../../assets/top_arrow.png" v-if="openPrivacy"/>
                    <img class="icon" src="../../../assets/bottom_arrow.png" v-else/>
                </div> 
                <div class="contents" v-if="openPrivacy">
                    <strong>수집 항목</strong><br/>
                    수진자 성명, 생년월일, <br/>
                    (대리작성 시)법정대리인 또는 가족 정보(성명, 생년월일, 관계), 작성자 휴대폰번호, 작성자 신분증(주민등록증, 운전면허증, 외국인등록증) 사본 내 개인정보, <br/> 
                    (차상위계층 증빙서류 체출 시)증빙서류 사본 내 개인정보 <br/> <br/>
                    
                    <strong>수집 목적</strong><br/>
                    위임장 제출을 통한 건강보험공단의 위임 청구 등록<br/><br/>

                    <strong>보유 및 이용 기간</strong><br/>
                    위임 종료일 당월 말일 로부터 2개월 까지
                </div>
                <div class="bar" @click="idOpen">
                    <span>고유식별정보 수집 및 이용 동의</span>
                    <img class="icon" src="../../../assets/top_arrow.png" v-if="openId"/>
                    <img class="icon" src="../../../assets/bottom_arrow.png" v-else/>
                </div>
                <div class="contents" v-if="openId">
                    <strong>수집 항목</strong><br>
                    주민(외국인)등록번호 (법적 근거 :  국민건강보험법 시행령 제81조(의료급여법시행령 제21조)), (운전면허증 사본 제출 시)운전면허번호<br><br>
                    <strong>수집 목적</strong><br>
                    위임장 제출을 통한 건강보험공단의 위임 청구 등록<br><br>

                    <strong>보유 및 이용 기간</strong><br>
                    위임 종료일 당월 말일 로부터 2개월 까지
                </div>
            </div>
        </div>
    </div>


</template>

<script>
import CloseButton from '@/components/atoms/CloseButton';

export default {
    name: 'terms',
    data: function()
    {
        return {
            openPrivacy: false,
            openId: false
        }
    },
    components: {
        CloseButton
    },
    mounted: function(){
        document.body.style.overflow = 'hidden'; // body 스크롤 잠금
    },  
    methods: {
        closeTerms: function()
        {
            document.body.style.overflow = ''; // body 스크롤 활성화
            this.$emit('onClose')
        },
        privacyOpen: function()
        {
            this.openPrivacy = !this.openPrivacy
        },
        idOpen: function()
        {
            this.openId = !this.openId;   
        }
    }
}
</script>

<style scoped>
    .wrapper {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .modal {
        position: fixed;   
        background: #fff;
        width: 100%;
        z-index: 10;
        top: 0;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-direction: column;
    }
    .terms{
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-direction: column;
        box-sizing: border-box;
        padding: 0 16px;
        height: 100dvh;
        overflow-y: auto; /* 이 요소에만 스크롤 활성화 */
        overflow-x: hidden;
    }

    @media (min-width: 600px) {
        .terms {
            width: 600px;
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            flex-direction: column;
            box-sizing: border-box;
            height: 100dvh;
            overflow-y: auto; /* 이 요소에만 스크롤 활성화 */
            overflow-x: hidden;
        }
    }

    .title {
        color: var(--primary-color1, #1E1E1E);
        font-family: Pretendard;
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        line-height: 28px; /* 116.667% */
    }
    .bar {
        width: 100%;
        min-height: 60px;
        display: flex;
        padding-right: 13px;
        justify-content: space-between;
        align-items: center;
        color: var(--primary-color1, #1E1E1E);
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        border-bottom: 1px solid #EDEEF0;
    }
    .icon {
        width: 13px;
    }
    .contents {
        width: 100%;
        padding: 20px;
        flex-shrink: 0;
        background: var(--Gray-20, #F3F5F8);
        box-sizing: border-box;
        color: var(--primary-color1, #1E1E1E);
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
    }
</style>


// WEBPACK FOOTER //
// src/components/organisms/contract/Terms.vue